/* eslint-disable eqeqeq */
import React, { useContext, useRef, useState, useEffect } from "react";
import { Link, useHistory, BrowserRouter } from "react-router-dom";
import StateContext from "../StateContext";
import DispatchContext from "../DispatchContext";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Badge from "@material-ui/core/Badge";
import CallIcon from "@material-ui/icons/Call";
import MailIcon from "@material-ui/icons/Mail";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import PersonIcon from "@material-ui/icons/Person";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import DialogTitle from "@mui/material/DialogTitle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import SidebarBanner from "./SidebarBanner";
import Axios from "axios";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import LoginModal from "./LoginModal";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import HelpIcon from "@material-ui/icons/Help";
import LoginDialog from "./LoginDialog";
// import MenuIcon from '@material-ui/icons/Menu';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Menu from "@mui/material/Menu";
import {
  NotificationActions,
  NotificationContainer,
} from "material-ui-notifications";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Checkbox from "@material-ui/core/Checkbox";
import Avatar from "@material-ui/core/Avatar";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { getCookie } from "../Functions/cookieFunction"
import { withTranslation, useTranslation, Trans } from "react-i18next";
import maleLogo from "../Assets/images/male-avatar.png";
import femaleLogo from "../Assets/images/female-avatar.png";
import { handleError } from "../Functions/getAlert";
import vendorsConfig from "../vendorsConfig";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    height: "100vh",
    alignItems: "center",
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Navbar(props) {

  const { t } = useTranslation();
  const [alertMessage, setAlertMessage] = useState({
    open: false,
    message: "",
  });
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(true);
  const minDesktop = useMediaQuery("(min-width: 992px)");
  const appDispatch = useContext(DispatchContext);
  const appState = useContext(StateContext);
  // const [appState.profile, setappState.profile] = useState(appState.profile);
  let history = useHistory();
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [menuAnchor, setMenuAnchor] = useState({ open: false });
  const [openModal, setOpenModal] = useState(false);
  const [notifyCount, setNotifyCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [counter, setCounter] = useState(0);
  const [count, setCount] = useState(1);
  const [auth, setAuth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };
  const handleCloseNoti = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    appDispatch({ type: "logout" });
    history.push('/');
  };
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setMenuAnchor({ open });
  };
  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const AllTabs = document.querySelectorAll(".tabs");
  const handleClick = (e) => {
    let tabValue = parseFloat(e.target.attributes.value.value);
    if (props.handleChange) {
      props.handleChange(AllTabs, tabValue);
    }
    setMenuAnchor({ open: false });
  };
  useEffect(() => {
    const handleTabToggle = () => {
      let tabIndex = 0;
      if (
        window.location.pathname ===
        `/dashboard/transactions`
      ) {
        tabIndex = 0;
      } else if (
        window.location.pathname === `/dashboard/promo`
      ) {
        tabIndex = 1;
      } else if (
        window.location.pathname === `/dashboard/profile`
      ) {
        tabIndex = 2;
      } else if (
        window.location.pathname === `/dashboard/orders`
      ) {
        tabIndex = 3;
      }
      if (props.handleChange) {
        props.handleChange(AllTabs, tabIndex);
      }
    };
    handleTabToggle();
  }, [window.location.pathname]);

  const handleModalOpen = (e) => {
    e.preventDefault();
    setOpenModal(true);
  };
  const walletShow = () => {

    if (appState.profile) {
      history.push("/wallet");
    } 
  };
  const arLanguageHandle = (e) => {
    appDispatch({
      type: "LangChange",
      langValue: "ar",
    });
    //   i18n.changeLanguage('ar')
  };
  const enLanguageHandle = (e) => {
    appDispatch({
      type: "LangChange",
      langValue: "en",
    });
  };
  useEffect(() => {
    setTimeout(
      () => setAlertMessage({ open: false, message: "", alertSuccess: false }),
      5000
    );
  }, [alertMessage.open]);

  useEffect(() => {
    const fetchNotification = async () => {
      setIsLoading(true);
      try {
        const response = await Axios.get(
          `${process.env.REACT_APP_API_URL}notification`,
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );
        var notiCount = 0;
        if (response.data.success == true) {
          response.data.data.map((val) => {
            if (!val.readed) {
              notiCount++;
            }
            // val.readed == true ? notiCount = notiCount + 1 : notiCount = notiCount ;
          });
          setNotifyCount(notiCount);
          setNotifications(response.data.data);
          setIsLoading(false);
        }

      } catch (e) {
        handleError(e, appDispatch)
       }
    };
    fetchNotification();



  }, [count]);

  useEffect(() => {
    if (notifyCount > 0) {
      setCounter(counter + 1)
    }
  }, [notifyCount]);


  const [checked, setChecked] = React.useState([1]);

  const handleToggl = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const handleReadNotification = async (notification, index) => {

    if (notification.readed == false) {
      try {
        const response = await Axios.post(

          `${process.env.REACT_APP_API_URL}notification/marked`,
          { id: notification.id },
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );

        setCount(count + 1);
      } catch (e) {
        handleError(e, appDispatch)

      }
    } else {
      try {
        const response = await Axios.post(

          `${process.env.REACT_APP_API_URL}notification/unmarked`,
          { id: notification.id },
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );

        setCount(count + 1);
      } catch (e) {
        handleError(e, appDispatch)

      }
    }
  };
  const handleReadNotificationAndRedirect = async (notification, index) => {

    if (notification.readed == false) {
      try {
        const response = await Axios.post(

          `${process.env.REACT_APP_API_URL}notification/marked`,
          { id: notification.id },
          {
            headers: {
              Authorization: `Bearer ${appState.token}`,
            },
          }
        );

        setCount(count + 1);
        window.open(
          `https://${window.location.host}/invoice/in/${notification.data.data.invoice.id}`,
          "_blank"
        );
      } catch (e) {
        handleError(e, appDispatch)

      }
    } else {
      try {
        window.open(
          `https://${window.location.host}/invoice/in/${notification.data.data.invoice.id}`,
          "_blank"
        );
      } catch (e) {
      }
    }
  };

  // Function for Mark all notification
  const markAll = async () => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}notification/markedall`,
        {},
        {
          headers: {
            Authorization: `Bearer ${appState.token}`,
          },
        }
      );
      setCount(count + 1);
    } catch (e) {
      handleError(e, appDispatch)
    }
  };


  // useEffect for updated profile data when user update profile
  // useEffect(() => {
  //   const profileUpdate = () => {
  //     setappState.profile(
  //       getCookie("Profile") != null
  //         ? JSON.parse(getCookie("Profile"))
  //         : appState.profile
  //     );
  //   };
  //   profileUpdate();
  // }, [appState.profile]);



  return (
    <div className="Navbar classForNotification">
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alertMessage.open}
        className={alertMessage.alertSuccess ? "success-alert" : "danger-alert"}
      >
        {alertMessage.alertSuccess ? (
          <Alert severity="success">{alertMessage.message}</Alert>
        ) : (
          <Alert severity="error">{alertMessage.message}</Alert>
        )}
      </Snackbar>
      <LoginModal
        setAlertMessage={props.setAlertMessage}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
      <nav className="navbar navbar-expand-lg navbar-light p-0 bg-light">
        <div className="container-fluid px-lg-5 px-3">
          <Link
            to={appState.loggedIn ? "/dashboard" : "/"}
            className="navbar-brand"
          >
            <img
              src={vendorsConfig.APP_LOGO}
              alt={vendorsConfig.APP_NAME}
              width="100"
            />
          </Link>
          {!minDesktop ? (
            <div className="d-flex">
              {auth && (
                <div className="d-flex">

                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="inherit"
                    className="nav_menu_toggler"
                  >
                    <Badge
                      badgeContent={notifyCount > 0 ? notifyCount : 0}
                      color="primary"
                    >
                      <NotificationsIcon />
                    </Badge>
                  </IconButton>


                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseNoti}
                  >
                    <ListItem>
                      <ListItemText className="notiTitle">
                        <h4>Notification</h4>
                      </ListItemText>

                      <ListItemAvatar className="notiTitle pb-1">
                        <Button
                          className="notificationReadAll  cursor-pointer"
                          onClick={() => markAll()}
                        >
                          Mark as Read all
                        </Button>
                      </ListItemAvatar>
                    </ListItem>

                    {notifications.map((notification, index) => {
                      return (
                        <div
                          className={`${notification.readed == true
                            ? "notificationReaded"
                            : "notificationNotReaded"
                            }`}
                        >
                          <ListItem key={index} button>
                            <ListItemAvatar>
                              <Avatar>
                                <ReceiptIcon />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              id={notification.id}
                              onClick={() =>
                                handleReadNotificationAndRedirect(
                                  notification,
                                  index
                                )
                              }
                            >
                              {notification.data.message} <br />
                            </ListItemText>
                          </ListItem>
                        </div>
                      );
                    })}
                  </Menu>
                </div>
              )}
              {appState.langValue === "ar" ? (
                <IconButton
                  id="headerBtn"
                  className=""
                  onClick={(e) => enLanguageHandle(e)}
                >
                  <span className="lang-text">EN</span>
                </IconButton>
              ) : (
                <IconButton
                  id="headerBtn"
                  className=""
                  style={{ padding: "12px 20px" }}
                  onClick={(e) => arLanguageHandle(e)}
                >
                  <span className="lang-text">ع</span>
                </IconButton>
              )}

              <IconButton
                color="primary"
                onClick={toggleDrawer(true)}
                className="nav_menu_toggler"
                aria-label="Menu"
              >
                <MenuIcon />
              </IconButton>
            </div>
          ) : (
            ""
          )}
          {/* Button ---- Space */}
          {minDesktop ? (
            <div
              className="collapse navbar-collapse navbarnotification"
              id="navbarNav"
            >
              <ul
                className={
                  appState.langValue === "ar"
                    ? "navbar-nav mr-auto"
                    : "navbar-nav ml-auto"
                }
              >
                {/* <li className="nav-item">
                                <Link to={`/wallet`} className="nav-link text-link">My Wallet</Link>
                            </li> */}
                {appState.loggedIn ? (
                  <>
                    {/* <li className="nav-item px-2">
                      <div className="nav-link">
                        <Link to="/dashboard">
                          {t("dashboard.transactions")}
                        </Link>
                      </div>
                    </li>
                    <li className="nav-item px-2">
                      <div className="nav-link">
                        <Link to="/dashboard/promo">
                          {t("dashboard.promocodes")}
                        </Link>
                      </div>
                    </li>
                    <li className="nav-item px-2">
                      <div className="nav-link">
                        <Link to="dashboard/orders">
                          {t("dashboard.orders")}
                        </Link>
                      </div>
                    </li> */}
                    {/* <li className="nav-item">
                      <div className="nav-link">
                      
                        <Button className="walletBtn" onClick={walletShow}>
                          <div className="row m-0 align-items-center navBarwalletIcon">
                            <AccountBalanceWalletIcon />
                            <div className="WalletInfomration">
                              <p>
                                <strong>
                                  <span className="amount">
                                    {appState.profile.wallet
                                      ? parseFloat(appState.profile.wallet.amount)
                                      : "0"}{" "}
                                  </span>

                                  <span className="{t("KWD")}">{t("KWD")}</span>
                                </strong>
                              </p>
                            </div>
                          </div>
                        </Button>
           
                      </div>
                    </li> */}
                    <li className="nav-item">
                      <div className="nav-link ">
                        {/* <Link to="/wallet"> */}

                        {auth && (
                          <div className="d-flex">

                            <IconButton
                              size="large"
                              aria-label="account of current user"
                              aria-controls="menu-appbar"
                              aria-haspopup="true"
                              onClick={handleMenu}
                              color="inherit"
                              className="nav_menu_toggler"
                            >
                              <Badge
                                badgeContent={notifyCount > 0 ? notifyCount : 0}
                                color="primary"
                              >
                                <NotificationsIcon />
                              </Badge>
                            </IconButton>

                            <Menu
                              id="menu-appbar"
                              anchorEl={anchorEl}
                              anchorOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              keepMounted
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "right",
                              }}
                              open={Boolean(anchorEl)}
                              onClose={handleCloseNoti}
                            >
                              {/* <div className="notificationTitle d-flex align-items-center justify-content-between ">
                                  <h4 className="">Notificaitons</h4>{" "}
                                  <span>Mark as all read</span>
                              </div> */}
                              <ListItem>
                                <ListItemText className="notiTitle">
                                  <h4>Notification</h4>
                                </ListItemText>

                                <ListItemAvatar className="notiTitle pb-1">
                                  <Button
                                    className="notificationReadAll  cursor-pointer"
                                    onClick={() => markAll()}
                                  >
                                    Mark as Read all
                                  </Button>
                                </ListItemAvatar>
                              </ListItem>

                              {notifications.map((notification, index) => {
                                return (
                                  <div
                                    className={`${notification.readed == true
                                      ? "notificationReaded"
                                      : "notificationNotReaded"
                                      }`}
                                  >
                                    <ListItem key={index} button>
                                      <ListItemAvatar>
                                        <Avatar>
                                          <ReceiptIcon />
                                        </Avatar>
                                      </ListItemAvatar>
                                      <ListItemText
                                        id={notification.id}
                                        onClick={() =>
                                          handleReadNotificationAndRedirect(
                                            notification,
                                            index
                                          )
                                        }
                                      >
                                        {notification.data.message} <br />
                                      </ListItemText>
                                    </ListItem>
                                  </div>
                                );
                              })}
                            </Menu>
                          </div>
                        )}

                        {/* </Link> */}
                      </div>
                    </li>
                    <li
                      className={`${appState.langValue === "ar" ? "" : "navbarENARButton"
                        } nav-item`}
                    >
                      {/* <div className="nav-link">

                                                <img width={15} src={`${process.env.REACT_APP_IMAGE_URL}unitedStates.png`} alt="" />
                                                <span className="text-white pl-2 small">EN</span>
                                            </div> */}
                      {appState.langValue === "ar" ? (
                        <IconButton
                          id="headerBtn"
                          className=""
                          onClick={(e) => enLanguageHandle(e)}
                        >
                          <span className="lang-text">EN</span>
                        </IconButton>
                      ) : (
                        <IconButton
                          id="headerBtn"
                          className=""
                          onClick={(e) => arLanguageHandle(e)}
                        >
                          <span className="lang-text">ع</span>
                        </IconButton>
                      )}
                    </li>
                    {/* <li className="nav-item">
                      <div className="nav-link">
                        <Link to="/">
                          <IconButton className="p-1">
                            <HelpIcon />
                          </IconButton>
                        </Link>
                      </div>
                    </li> */}

                    <li className="nav-item">
                      {/* Button */}
                      <ButtonGroup ref={anchorRef} aria-label="split button">
                        <Button
                          size="small"
                          className="border-0"
                          onClick={toggleDrawer(true)}
                        >
                          {/* <PersonIcon className="userIcon" />
                                        <ArrowDropDownIcon /> */}
                          <div>
                            {/* <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="35"
                              height="40"
                              viewBox="0 0 46 52.089"
                            >
                              <defs>
                                <clipPath id="clipPath">
                                  <ellipse
                                    id="Ellipse_11"
                                    data-name="Ellipse 11"
                                    cx="23"
                                    cy="23.5"
                                    rx="23"
                                    ry="23.5"
                                    transform="translate(0.092 0.033)"
                                    fill="#322a7d"
                                  />
                                </clipPath>
                              </defs>
                              <g
                                id="Group_17587"
                                data-name="Group 17587"
                                transform="translate(-264.477 -121)"
                              >
                                <ellipse
                                  id="Ellipse_10"
                                  data-name="Ellipse 10"
                                  cx="23"
                                  cy="23.5"
                                  rx="23"
                                  ry="23.5"
                                  transform="translate(264.477 126.089)"
                                  fill="#1c202e"
                                />
                                <circle
                                  id="Ellipse_6"
                                  data-name="Ellipse 6"
                                  cx="2.278"
                                  cy="2.278"
                                  r="2.278"
                                  transform="translate(294.87 134.724)"
                                  fill="#d98f67"
                                />
                                <circle
                                  id="Ellipse_7"
                                  data-name="Ellipse 7"
                                  cx="2.278"
                                  cy="2.278"
                                  r="2.278"
                                  transform="translate(275.13 134.724)"
                                  fill="#d98f67"
                                />
                                <path
                                  id="Path_4"
                                  data-name="Path 4"
                                  d="M22.427,38.024,17,31.512V25H27.854v6.512Z"
                                  transform="translate(264.726 118.793)"
                                  fill="#d98f67"
                                />
                                <path
                                  id="Path_5"
                                  data-name="Path 5"
                                  d="M32.537,13.408c0-8.249-19.537-5.427-19.537,0v7.6a9.768,9.768,0,0,0,19.537,0Z"
                                  transform="translate(264.385 117.361)"
                                  fill="#e59e76"
                                />
                                <path
                                  id="Path_6"
                                  data-name="Path 6"
                                  d="M22.854,4C16.233,4,12,9.318,12,15.939v2.5l2.171,1.845V14.854L27.2,10.512l4.341,4.341v5.427l2.171-1.845v-2.5c0-4.341-1.085-8.683-6.512-9.768L26.11,4H22.854Z"
                                  transform="translate(264.299 117)"
                                  fill="#000001"
                                />
                                <g
                                  id="Mask_Group_1"
                                  data-name="Mask Group 1"
                                  transform="translate(264.385 126.056)"
                                  clipPath="url(#clipPath)"
                                >
                                  <path
                                    id="Path_7"
                                    data-name="Path 7"
                                    d="M28.793,31h0a13.169,13.169,0,0,1-5.427,1.085A13.169,13.169,0,0,1,17.939,31S6,33.171,6,45.11L24.69,65.493,40.732,45.11C40.732,33.171,28.793,31,28.793,31Z"
                                    transform="translate(-0.597 -6.751)"
                                    fill="#ffc138"
                                  />
                                </g>
                              </g>
                            </svg> */}
                            {appState.profile.image ? (
                              <img
                                src={appState.profile.image}
                                alt=""
                                height="50px"
                                width="50px"
                                style={{ borderRadius: "50%" }}
                              />
                            ) : (
                              <img
                                src={maleLogo}
                                alt=""
                                height="50px"
                                width="50px"
                              />
                            )}
                          </div>
                          <p  className=" m-0 px-2">{appState.profile.userFirstName}</p>
                          {/* <MenuIcon /> */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8.816"
                            height="4.776"
                            viewBox="0 0 8.816 4.776"
                          >
                            <g
                              id="down-arrow"
                              transform="translate(0 -117.336)"
                            >
                              <g
                                id="Group_892"
                                data-name="Group 892"
                                transform="translate(0 117.336)"
                              >
                                <path
                                  id="Path_3393"
                                  data-name="Path 3393"
                                  d="M8.709,117.444a.367.367,0,0,0-.519,0l-3.781,3.781L.627,117.444a.367.367,0,0,0-.519.519L4.149,122a.367.367,0,0,0,.519,0l4.041-4.041A.367.367,0,0,0,8.709,117.444Z"
                                  transform="translate(0 -117.336)"
                                  fill="#fff"
                                />
                              </g>
                            </g>
                          </svg>
                        </Button>
                      </ButtonGroup>
                      {/* Popper For The Menu */}
                      <Popper
                        open={open}
                        anchorEl={anchorRef.current}
                        className="popper"
                        role={undefined}
                        transition
                        disablePortal
                      >
                        {({ TransitionProps, placement }) => (
                          <Grow
                            {...TransitionProps}
                            style={{
                              transformOrigin:
                                placement === "bottom"
                                  ? "center top"
                                  : "center bottom",
                            }}
                          >
                            <Paper>
                              <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu">
                                  <MenuItem className="navMenuItem">
                                    <Link
                                      value={0}
                                      to={`/dashboard/transactions`}
                                      onClick={handleClick}
                                    >
                                      {" "}
                                      <i
                                        class="fas fa-history pr-2"
                                        aria-hidden="true"
                                      ></i>
                                      Transactions
                                    </Link>
                                  </MenuItem>
                                  <MenuItem
                                    id="simple-menu-0"
                                    className="navMenuItem"
                                  >
                                    <Link
                                      value={1}
                                      to={`/dashboard/promo`}
                                      onClick={handleClick}
                                    >
                                      <i
                                        class="fas fa-percent pr-2"
                                        aria-hidden="true"
                                      ></i>
                                      {t("dashboard.promocodes")}
                                    </Link>
                                  </MenuItem>
                                  <MenuItem
                                    id="simple-menu-0"
                                    className="navMenuItem"
                                  >
                                    <Link
                                      value={2}
                                      to={`/dashboard/profile`}
                                      onClick={handleClick}
                                    >
                                      <i className="far fa-user pr-2"></i>{" "}
                                      {t("dashboard.my-profile")}
                                    </Link>
                                  </MenuItem>
                                  <MenuItem
                                    id="simple-menu-0"
                                    className="navMenuItem"
                                  >
                                    <Link
                                      value={3}
                                      to={`/dashboard/orders`}
                                      onClick={handleClick}
                                    >
                                      <i className="fas fa-list-ul pr-2"></i>
                                      {t("dashboard.orders")}
                                    </Link>

                                    <Link

                                      value={4}
                                      to={`/dashboard/rewards`}
                                      onClick={handleClick}
                                    >
                                      {" "}
                                      <i
                                        class="fas fa-history pr-2"
                                        aria-hidden="true"
                                      ></i>
                                      Rewards
                                    </Link>
                                  </MenuItem>
                                  <MenuItem
                                    className="navMenuItem"
                                    onClick={handleLogout}
                                  >
                                    <strong>
                                      <i class="fas fa-sign-out-alt pr-2"></i>
                                      Logout
                                    </strong>
                                  </MenuItem>
                                </MenuList>
                              </ClickAwayListener>
                            </Paper>
                          </Grow>
                        )}
                      </Popper>
                    </li>
                  </>
                ) : (
                  <>
                    <li className="nav-item">
                      <LoginDialog />
                      {/* <Button variant="contained" className="bg-primary-light" onClick={handleModalOpen} >Login</Button> */}
                    </li>
                  </>
                )}
              </ul>
            </div>
          ) : (
            ""
          )}
        </div>
      </nav>
      {/* {!minDesktop ? */}
      <div>
        <SwipeableDrawer
          anchor={appState.langValue === "ar" ? "right" : "left"}
          open={menuAnchor.open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          <div>
            <div
              className="mob-menu-items"
              style={appState.langValue === "ar" ? { direction: "rtl" } : {}}
            >
              {appState.loggedIn ? (
                <div
                style={{display:"none"}}
                  className={`mb-4 mt-2 ${appState.langValue === "ar"
                    ? "d-flex  flex-column align-items-start "
                    : ""
                    }`}
                >
                  <h4 className="mb-0 text-uppercase">
                    {appState.loggedIn ? appState.profile.userFirstName : ""}
                  </h4>
                  <Link to="/wallet">
                    <p className="small text-muted mb-1">
                      {t("drawer.view-wallet")}
                    </p>
                  </Link>
                  <h3 className="text-primary mb-0">
                    {appState.profile.wallet
                      ? parseFloat(appState.profile.wallet.amount)
                      : "0"}{" "}
                    <span className="small-KD text-primary">{t("KWD")}</span>
                  </h3>
                </div>
              ) : (
                ""
              )}
              <MenuList className="navMenuList">
                <MenuItem className="side-menu-item">
                  <Link
                    value={2}
                    to={`/dashboard/profile`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    <i
                      className={
                        appState.langValue === "ar"
                          ? "fas fa-user text-primary pl-4"
                          : "fas fa-user text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.my-profile")}
                  </Link>
                </MenuItem>
                <MenuItem className="side-menu-item">
                  <Link
                    value={0}
                    to={`/dashboard/transactions`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    {/* <i className="fas fa-history pr-4"></i> */}
                    {/* <img
                      src={`${process.env.REACT_APP_IMAGE_URL}exchangeIcon.png`}
                      className={
                        appState.langValue === "ar"
                          ? "img-fluid pl-2"
                          : "img-fluid pr-2"
                      }
                      alt=""
                    />{" "} */}
                    <i
                      className={
                        appState.langValue === "ar"
                          ? "fas fa fa-refresh text-primary pl-4"
                          : "fas fa fa-refresh text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.transactions")}
                  </Link>
                </MenuItem>
                <MenuItem className="side-menu-item">
                  <Link
                    value={1}
                    to={`/dashboard/promo`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    <i
                      className={
                        appState.langValue == "ar"
                          ? "fas fa-percent text-primary pl-4"
                          : "fas fa-percent text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.promocodes")}
                  </Link>
                </MenuItem>

                <MenuItem className="side-menu-item">
                  <Link
                    value={3}
                    to={`/dashboard/orders`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    {/* <i className="fas fa-list-ul pr-4"></i> */}
                    {/* <img
                    style={{border:"2px solid red"}}
                      src={`${process.env.REACT_APP_IMAGE_URL}received.png`}
                      className={
                        appState.langValue === "ar"
                          ? "img-fluid pl-2"
                          : "img-fluid pr-2"
                      }
                      alt=""
                    /> */}
                    <i
                      className={
                        appState.langValue == "ar"
                          ? "fas fa fa-inbox text-primary pl-4"
                          : "fas fa fa-inbox text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.orders")}
                  </Link>
                </MenuItem>
                {/* <MenuItem className="side-menu-item">
                  <Link
                    value={3}
                    to={`/dashboard/orders`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    <i
                      class={
                        appState.langValue === "ar"
                          ? "fas fa-headset text-primary pl-4"
                          : "fas fa-headset text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.support")}
                  </Link>
                </MenuItem> */}
                {/* <MenuItem className="side-menu-item">
                  <Link
                    value={3}
                    to={`/dashboard/orders`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    <i
                      className={
                        appState.langValue === "ar"
                          ? "fas fa-globe text-primary pl-4"
                          : "fas fa-globe text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.language")}
                  </Link>
                </MenuItem> */}
                <MenuItem className="side-menu-item">
                  <Link
                    value={4}
                    to={`/dashboard/rewards`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    <i
                      className={
                        appState.langValue === "ar"
                          ? "fa fa-trophy text-primary pl-4"
                          : "fa fa-trophy text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.rewards")}
                  </Link>
                </MenuItem>
                {/* <MenuItem className="side-menu-item">
                  <Link
                    value={3}
                    to={`/dashboard/orders`}
                    onClick={handleClick}
                    className="d-flex"
                  >
                    <i
                      className={
                        appState.langValue === "ar"
                          ? "fas fa-info-circle text-primary pl-4"
                          : "fas fa-info-circle text-primary pr-4"
                      }
                    ></i>
                    {t("dashboard.about")}
                  </Link>
                </MenuItem> */}

                <div className="logoutButton__icon">
                  <Button
                    className={`${appState.langValue === "ar" ? "d-flex btnRtl" : "d-flex"
                      } `}
                    onClick={handleLogout}
                  >
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}logout.png`}
                      width={35}
                      className={appState.langValue === "ar" ? "pl-3" : "pr-3"}
                      alt=""
                    />{" "}
                    {t("drawer.log-out-btn")}
                  </Button>
                </div>
              </MenuList>
            </div>
          </div>
        </SwipeableDrawer>
        <div className="nav-mob"></div>
      </div>
      {/* } */}
    </div>
  );
}

export default withTranslation()(Navbar);
